import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ActivityGroupService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IActivityGroup } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapActivityGroupFromEntity, mapActivityGroupFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getActivityGroup(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.getActivityGroup(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityGroupFromEntity(response.data.attributes["activityGroup"] || {});

            if (!notFill) {
                dispatch(initialPageData<IActivityGroup>(mapped));
            }

            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getActivityGroupByLanguage(pageData: IActivityGroup, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.getActivityGroup(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityGroupFromEntity(response.data.attributes["activityGroup"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IActivityGroup>(data));
            if (isOverride) {
                dispatch(updateActivityGroup(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createActivityGroup({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getActivityGroup(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getActivityGroups(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.getActivityGroups(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityGroupFromEntity(item)
            );
            dispatch(initialPageData<IList<IActivityGroup[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getActivityGroupsForLocal(language: string): ThunkResult<Promise<IActivityGroup[]>> {
    return async () => {
        const service = new ActivityGroupService();
        const response = await service.getActivityGroups({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityGroupFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function createActivityGroup(request: IActivityGroup): ThunkResult<Promise<IActivityGroup | null>> {
    return async (dispatch) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.createActivityGroup(mapActivityGroupFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapActivityGroupFromEntity(response.data.attributes["activityGroup"] || {});
        }
        return null;
    };
}

export function updateActivityGroup(request: IActivityGroup): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.updateActivityGroup(mapActivityGroupFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteActivityGroup(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityGroupService();
        dispatch(toggleLoader());
        const response = await service.deleteActivityGroup(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}